import { Injectable, Component } from '@angular/core';
import { NgbModal } from '@otas/modal/modal';
import { HttpClient } from '@angular/common/http';
import { AppConstants } from '../../../app.constants';
import { Observable } from 'rxjs';

@Injectable()
export class ProductModalService {

  constructor(public modalService: NgbModal, private http: HttpClient) { }
  openModal(component: Component, heading, data, buttonName) {
    const modalRef = this.modalService.open(component, AppConstants.largeModaloptions);
    modalRef.componentInstance.heading = heading;
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.buttonName = buttonName;
    return modalRef;
  }
  getAllUnit(): Observable<any> {
    return this.http.get<any>(`unit`);
  }
  getAllExpenseAccount(): Observable<any> {
    return this.http.get<any>(`account-head/expense`);
  }
  getAllIncomeAccount(): Observable<any> {
    return this.http.get<any>(`account-head/income`);
  }
  getAllMaterialCategory(): Observable<any> {
    return this.http.get<any>(`material-category`);
  }
  submitMaterialCategory(data): Observable<any> {
    return this.http.post<any>(`material-category`, data);
  }
  addMaterial(object): Observable<any> {
    object.quantity = 0;
    if (!!object.productId) {
      return this.http.put<any>(`temple/material/${object.productId}`, object);
    } else {
      return this.http.post<any>(`temple/material`, object);
    }

  }
  getAllStore(): Observable<any> {
    return this.http.get<any>(`temple/store`);
  }
}
